/* eslint-disable new-cap */
import { createGlobalStyle } from "styled-components";
import { FormStyles } from "./FormStyles";
import { HelpStyles } from "./HelpStyles";

export const Styles = createGlobalStyle`
    ${FormStyles};
    ${HelpStyles};

    #content.customer-support-centre .customer-form textarea,
    #content .account__help-content .customer-form textarea,
    #content.help .customer-form textarea {
        margin-bottom: 0 !important;
    }

    .breadcrumb .breadcrumb__list-item .breadcrumb__list-item-link:after, #content .breadcrumb .breadcrumb__list-item .breadcrumb__list-item-link:after {
        content: "\\203A";
        display: inline-block;
    }
    
    .breadcrumb .breadcrumb__list-item .breadcrumb__list-item-link:after, #content .breadcrumb .breadcrumb__list-item .breadcrumb__list-item-link:after {
        margin: 0 4px;
    }
`;
